// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2Cpnz","content":"Consent_content__2eNW5","footer":"Consent_footer__3dc9u"};